import removeItem from "../array/remove_item"
import getWebWorkerJobsList from "./getWebWorkerJobsList"
import type { HasJobId } from "./HasJobId.type"

interface WebWorkerJobResult extends HasJobId {
  error?: unknown
}

export default function resolveWebWorkerJob(
  worker: Worker,
  result: WebWorkerJobResult
): void {
  const jobsList = getWebWorkerJobsList(worker)
  for (const job of jobsList) {
    if (job.j === result.j) {
      // console.log('resolveWebWorkerJob', 'resolved!', result.j)
      if (result.error) {
        job.reject(result.error)
      } else {
        job.resolve(result)
      }
      removeItem(jobsList, job)
      return
    }
  }

  // console.log('resolveWebWorkerJob', 'not resolved!', result.j)
}